import { render, staticRenderFns } from "./PopupLogoutConfirmation.vue?vue&type=template&id=18d04439"
import script from "./PopupLogoutConfirmation.vue?vue&type=script&lang=js"
export * from "./PopupLogoutConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports